module.exports = __webpack_public_path__ + "static/media/Rampardos_gaussian2.33ec9239.png";